import { Zap, Globe, Download, History, FileBarChart2, Headset } from 'lucide-react';

const ITEMS = [
  { icon: Zap, title: 'Conciliación en menos de un minuto', text: 'Procesa miles de movimientos al instante, sin esperas.' },
  { icon: Globe, title: 'Aplicación 100% web', text: 'Trabaja desde cualquier navegador, en cualquier equipo.' },
  { icon: Download, title: 'Sin instalaciones', text: 'Nada que descargar ni mantener. Solo entra y usa.' },
  { icon: History, title: 'Historial permanente', text: 'Consulta cualquier conciliación pasada cuando la necesites.' },
  { icon: FileBarChart2, title: 'Reportes claros', text: 'Exporta informes en Excel y PDF listos para presentar.' },
  { icon: Headset, title: 'Soporte para contadores y empresas', text: 'Pensado para firmas contables y equipos financieros.' },
];

export default function Benefits() {
  return (
    <section id="beneficios" className="py-20 md:py-28 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-extrabold text-navy-900 tracking-tight">
            Todo lo que necesitas para conciliar sin dolores de cabeza.
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {ITEMS.map((item) => (
            <div
              key={item.title}
              className="rounded-2xl border border-slate-200 p-7 hover:border-brand-green/40 hover:shadow-lg transition-all duration-300"
            >
              <span className="flex items-center justify-center w-12 h-12 rounded-xl bg-navy-900 text-white mb-5">
                <item.icon size={22} />
              </span>
              <h3 className="font-bold text-navy-900 mb-2">{item.title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
